import { deepCopyUtil } from "../util/util";

export interface Walls {
  topWalls: number[][];
  rightWalls: number[][];
  addTopWall(r: number, c: number): void;
  addRightWall(r: number, c: number): void;
  rightWall(r: number, c: number): boolean;
  topWall(r: number, c: number): boolean;
  isMoveValid(
    startR: number,
    startC: number,
    endR: number,
    endC: number,
  ): boolean;
  deepCopy(): Walls;
}

export function Walls(rows: number, cols: number): Walls {
  const that: Walls = {
    topWalls: [],
    rightWalls: [],

    addTopWall(r: number, c: number): void {
      that.topWalls[r][c] = 1;
    },

    addRightWall(r: number, c: number): void {
      that.rightWalls[r][c] = 1;
    },

    rightWall(r: number, c: number): boolean {
      return that.rightWalls[r][c] !== 0;
    },

    topWall(r: number, c: number): boolean {
      return that.topWalls[r][c] !== 0;
    },

    isMoveValid(
      startR: number,
      startC: number,
      endR: number,
      endC: number,
    ): boolean {
      if (endC < 0 || endC >= cols) return false;
      if (endR < 0 || endR >= rows) return false;

      const dRow = Math.abs(endR - startR);
      const dCol = Math.abs(endC - startC);
      if (dRow + dCol !== 1) return false;

      if (startC + 1 === endC && that.rightWalls[startR][startC]) return false;
      if (startC - 1 === endC && that.rightWalls[endR][endC]) return false;

      if (startR + 1 === endR && that.topWalls[endR][endC]) return false;
      if (startR - 1 === endR && that.topWalls[startR][endC]) return false;

      return true;
    },

    deepCopy(): Walls {
      const newModel = Walls(rows, cols);
      newModel.rightWalls = deepCopyUtil(that.rightWalls);
      newModel.topWalls = deepCopyUtil(that.topWalls);
      return newModel;
    },
  };

  for (let i = 0; i < rows; i++) {
    that.topWalls[i] = [];
    that.rightWalls[i] = [];
    for (let j = 0; j < cols; j++) {
      that.topWalls[i][j] = 0;
      that.rightWalls[i][j] = 0;
    }
  }

  return that;
}
